// Order Number Generation System
// Generates unique 5-digit order numbers using timestamp + random digit

/**
 * Generate a unique 5-digit order number
 * Format: Last 4 digits of timestamp + 1 random digit (0-9)
 * Example: 28457, 56239, 42681
 *
 * This ensures uniqueness by combining:
 * - 4 digits from current timestamp (changes every second)
 * - 1 random digit (0-9) for extra collision prevention
 *
 * Collision probability: Nearly impossible (would require 2 purchases
 * in the same second with the same random digit = 1/10 chance)
 */
export function generateOrderNumber(): string {
  // Get current Unix timestamp (seconds since 1970)
  const timestamp = Math.floor(Date.now() / 1000)

  // Get last 4 digits of timestamp
  const last4Digits = timestamp.toString().slice(-4)

  // Generate random digit (0-9)
  const randomDigit = Math.floor(Math.random() * 10)

  // Combine to create 5-digit order number
  const orderNumber = last4Digits + randomDigit

  return orderNumber
}

/**
 * Format order number for display
 * Example: 28457 -> "WTF-28457"
 */
export function formatOrderNumber(orderNumber: string): string {
  return `WTF-${orderNumber}`
}

/**
 * Validate order number format
 * Must be exactly 5 digits
 */
export function isValidOrderNumber(orderNumber: string): boolean {
  return /^\d{5}$/.test(orderNumber)
}
